import EventsManager from 'managers/events.manager';
import { Store } from 'stores/type';

const TEST_URL = 'https://littlealchemy2.com/static/online';

class ConnectivityManager {
  private $store!: Store;

  public init(store: Store) {
    this.$store = store;

    this.initEvents();
    this.isOnline();
  }

  private initEvents() {
    window.addEventListener('online', () => this.notify(true));
    window.addEventListener('offline', () => this.notify(false));
  }

  public isOnline() {
    const online = navigator.onLine;
    if (online) {
      return this.testConnection().then((result) => this.notify(result));
    }

    this.notify(false);
    return Promise.reject();
  }

  private notify(online: boolean) {
    const event = online ? 'ONLINE' : 'OFFLINE';
    EventsManager.emit(event);

    const action = online ? 'online' : 'offline';
    this.$store.dispatch(action);

    return online;
  }

  private testConnection(): Promise<boolean> {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open('HEAD', TEST_URL);
      xhr.send();
      xhr.onprogress = () => resolve(true);
      xhr.onload = () => resolve(true);
      xhr.onerror = () => resolve(false);
    });
  }
}

export default new ConnectivityManager();
